import { api } from '@setplex/tria-api'
import { combine, createEvent, sample } from 'effector'
import { not } from 'patronum'
import { tvPurchasedEntityModel } from '~/entities/tv/purchased'

export const loadGridPurchasedTvChannels = createEvent()

sample({
  clock: loadGridPurchasedTvChannels,
  filter: not(api.tv.getPurchasedTvChannelsGridFx.pending),
  target: api.tv.getPurchasedTvChannelsGridFx,
})

export const $isGridPurchasedTvChannelsLoading = combine(
  {
    purchasedTvChannelsLoading: api.tv.getPurchasedTvChannelsGridFx.pending,
    purchasedTvChannels: tvPurchasedEntityModel.$purchasedTvChannelsGrid,
  },
  ({ purchasedTvChannelsLoading, purchasedTvChannels }) =>
    !purchasedTvChannels && purchasedTvChannelsLoading
)

export const loadMoreGridPurchasedTvChannels = createEvent()

sample({
  clock: loadMoreGridPurchasedTvChannels,
  filter: not(api.tv.getPurchasedTvChannelsGridFx.pending),
  fn: () => null,
  target: tvPurchasedEntityModel.loadMorePurchasedTvChannelsGrid,
})
